import { render, staticRenderFns } from "./TransactionHistoryListPage.vue?vue&type=template&id=8a83fa40&scoped=true&"
import script from "./TransactionHistoryListPage.vue?vue&type=script&lang=js&"
export * from "./TransactionHistoryListPage.vue?vue&type=script&lang=js&"
import style0 from "./TransactionHistoryListPage.vue?vue&type=style&index=0&id=8a83fa40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a83fa40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a83fa40')) {
      api.createRecord('8a83fa40', component.options)
    } else {
      api.reload('8a83fa40', component.options)
    }
    module.hot.accept("./TransactionHistoryListPage.vue?vue&type=template&id=8a83fa40&scoped=true&", function () {
      api.rerender('8a83fa40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/TransactionHistoryListPage.vue"
export default component.exports